import ActionInput from '../../../components/common/actioninput/ActionInputField';
import DeleteIcon from '@mui/icons-material/Delete';
import './ApprovalCard.css'
import './index.css'
import ButtonComponent from '../../../components/common/button/Button';
import { IconButton } from '@mui/material';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
const WorkFlowApproval = ({ key, allNamesFilled, checkBoxCount, comments, onChangeComments, disableAddApprovalButton, allUsers, rows, handleChangeApprover, addApprover, onHandleDeleteIcon, className, handleClearAll }) => {
  return (
    <div className={className || 'sendForApproval_cls'}>
      <div className='approval-items-wrapper'>
        <p style={{ marginTop: '8px', fontSize: '14px' }}>No.of Line Items for Approval</p>
        <ActionInput
          value={checkBoxCount}
          props={{
            height: "30px", maxWidth: "70px",
            disabled: true
          }}
        />
      </div>
      <div className='approval-wrapper'>
        <div className='approver-header'>
          <div className='smallWidth-column'>Level</div>
          <div className='largeWidth-column'>Approver Name</div>
          <div className='largeWidth-column'>Email ID </div>
          <div className='deleteIcon-column'><p></p></div>
        </div>
        {rows.map((item, index) => (
          <div className='sendForApprover-container' key={index}>
            <div style={{ paddingTop: "16px", paddingBottom: "10px", paddingLeft: "10px", display: 'flex', alignItems: 'center' }} className='smallWidth-column'>{index + 1}</div>
            <div style={{ paddingTop: "10px", paddingBottom: "10px", }} className='largeWidth-column'>
              <Autocomplete
                key={key}
                className="custom-autocomplete"
                freeSolo
                options={allUsers}
                getOptionLabel={(option) => option.name}
                getOptionDisabled={(option) =>
                  rows.some(user => user.email === option.email)
                }
                renderInput={(params) => <TextField {...params}
                  // label="Search"
                  InputLabelProps={{ shrink: false }}
                  placeholder='Search Approver'

                />}
                onChange={(event, value) => handleChangeApprover(index, event, value)}
                style={{ height: 40, maxWidth: 220 }}
                value={allUsers.find(obj => obj.name === item.name) || null}
                disabled={(rows?.length - 1) !== index}
              />
            </div>
            <div className='largeWidth-column' style={{ paddingTop: "10px", paddingBottom: "10px" }}>
              <ActionInput
                value={item.email}
                props={{ height: "40px", maxWidth: "220px", }}
                placeholder='Email'
                disabled={true}
              />
            </div>
            <div className='deleteIcon-column' style={{ paddingTop: "10px", textAlign: "right" }}>
              <IconButton>
                {rows.length !== 1 && <DeleteIcon onClick={() => onHandleDeleteIcon(index)} />}
              </IconButton>
            </div>
          </div>
        ))}
      </div>
      {rows?.length < 3 && <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '40px', marginTop: "15px" }}>
        <ButtonComponent
          maxWidth="170px"
          label="Add Approver"
          type="primary"
          disabled={!allNamesFilled}
          onClick={addApprover}
        />
      </div>}
      <div>
        <label style={{ fontSize: '14px' }}>Comments</label>
        <div>
          <TextField multiline minRows={3} placeholder='Kindly check the Lead time and approve.' style={{ width: '100%' }} onChange={onChangeComments} value={comments} />
        </div>
      </div>
    </div>
  )
}

const WorkFlowApprovalFooter = ({ disableSubmitButton, submitLabel, clearAllLabel, handleClearAll, sendForApprovalAPI }) => {

  return (
    <div className='footer-btn-wrapper'>
      <ButtonComponent
        maxWidth="170px"
        label={clearAllLabel || "Clear All"}
        type="primary"
        onClick={handleClearAll}
      />
      <ButtonComponent
        maxWidth="170px"
        label={submitLabel || "Submit"}
        bgColor="black"
        color="white"
        onClick={sendForApprovalAPI}
        disabled={disableSubmitButton}
      />
    </div>
  );
};

export { WorkFlowApproval, WorkFlowApprovalFooter }